<template>
  <pict
    class="book-share__image m-auto w-full"
    block-name="book-share"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageLEN from "../images/avatars.png"
import imageL2xEN from "../images/avatars@2x.png"
import imageSEN from "../images/avatars_s.png"
import imageS2xEN from "../images/avatars_s@2x.png"
import imageB2bLEN from "../images/avatars_b2b.png"
import imageB2bL2xEN from "../images/avatars_b2b@2x.png"
import imageB2bSEN from "../images/avatars_b2b_s.png"
import imageB2bS2xEN from "../images/avatars_b2b_s@2x.png"
import imageLDE from "../images/avatars_de.png"
import imageL2xDE from "../images/avatars@2x_de.png"
import imageSDE from "../images/avatars_s_de.png"
import imageS2xDE from "../images/avatars_s@2x_de.png"
import imageB2bLDE from "../images/avatars_b2b_de.png"
import imageB2bL2xDE from "../images/avatars_b2b@2x_de.png"
import imageB2bSDE from "../images/avatars_b2b_s_de.png"
import imageB2bS2xDE from "../images/avatars_b2b_s@2x_de.png"

export default {
  name: "AvatarImage",
  components: {
    Pict
  },
  props: {
    spaceB2b: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    useDEImages() {
      return this.$i18n.locale === "de"
    },
    imageProps() {
      return this.spaceB2b ? this.b2bImageProps : this.b2cImageProps
    },
    b2cImageProps() {
      return {
        default: {
          src: this.useDEImages ? imageLDE : imageLEN,
          srcset: {
            "2x": this.useDEImages ? imageL2xDE : imageL2xEN
          }
        },
        sources: [
          {
            media: "s",
            src: this.useDEImages ? imageSDE : imageSEN,
            srcset: {
              "2x": this.useDEImages ? imageS2xDE : imageS2xEN
            }
          },
          {
            media: "m",
            src: this.useDEImages ? imageSDE : imageSEN,
            srcset: {
              "2x": this.useDEImages ? imageS2xDE : imageS2xEN
            }
          }
        ]
      }
    },
    b2bImageProps() {
      return {
        default: {
          src: this.useDEImages ? imageB2bLDE : imageB2bLEN,
          srcset: {
            "2x": this.useDEImages ? imageB2bL2xDE : imageB2bL2xEN
          }
        },
        sources: [
          {
            media: "s",
            src: this.useDEImages ? imageB2bSDE : imageB2bSEN,
            srcset: {
              "2x": this.useDEImages ? imageB2bS2xDE : imageB2bS2xEN
            }
          },
          {
            media: "m",
            src: this.useDEImages ? imageSDE : imageSEN,
            srcset: {
              "2x": this.useDEImages ? imageB2bS2xDE : imageB2bS2xEN
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Avatars representing different ethnicities plus 'YOU'"
      },
      de: {
        alt: "Avatare verschiedener Ethnien plus 'YOU'"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.book-share {
  ::v-deep &__image {
    width: auto;
  }
}
</style>
